import superagent from "superagent";
import { omitBy, isUndefined, isNull } from "lodash";
import store from "store2";
import config from "../config";
import moment from "moment";

const methods = ["get", "post", "put", "patch", "del"];

const API_HOSTS = {
  goApi: config.goApi,
  default: config.apiHost,
};

function formatUrl(path, apiType = "default") {
  if (!path) {
    return path;
  }

  if (/^(\/\/|http|https)/.test(path)) {
    return path;
  }
  const adjustedPath = path[0] !== "/" ? `/${path}` : path;
  const baseUrl = API_HOSTS[apiType] || API_HOSTS.default;
  return `${baseUrl}${adjustedPath}`;
}

export default class ApiClient {
  constructor(req) {
    methods.forEach((method) => {
      this[method] = this._req(method);
    });
  }
  // Default request timeout and retry policy
  _req = (method) => (path, { params, data, files, apiType } = {}) =>
    new Promise((resolve, reject) => {
      const DEFAULT_TIMEOUT_MS = 60000; // 60s response timeout
      const MAX_RETRIES = 2;
      const RETRY_DELAY_MS = 1000;

      let attempts = 0;

      const doRequest = () => {
        attempts += 1;
        const request = superagent[method](formatUrl(path, apiType));

        if (params) {
          const emptySting = (val) => val === "";
          const cleanFromUndefined = omitBy(params, isUndefined);
          const cleanFromNull = omitBy(cleanFromUndefined, isNull);
          const allCleaned = omitBy(cleanFromNull, emptySting);
          request.query(allCleaned);
        }

        request.send(data);

        const token = store("authToken");
        if (token) request.set("Authorization", "bearer " + token);

        request.set("x-user-date-time", moment().format("Y-MM-DD")); // Send user machine's date time in header

        // apply sensible timeouts to avoid long-hanging requests
        try {
          request.timeout({ response: DEFAULT_TIMEOUT_MS, deadline: DEFAULT_TIMEOUT_MS * 2 });
        } catch (e) {
          // some environments may not support the timeout API; ignore safely
        }

        request.end((err, res) => {
          const body = res && res.body;
          if (err) {
            const isTransient = (err.code === 'ECONNRESET') || (err.message && err.message.includes('socket hang up')) || err.timeout;
            if (isTransient && attempts <= MAX_RETRIES) {
              // retry after a short backoff
              try { console.warn(`[ApiClient] transient error: ${err.message}. retry ${attempts}/${MAX_RETRIES}`); } catch (e) {}
              setTimeout(doRequest, RETRY_DELAY_MS * attempts);
              return;
            }

            const errorObj = Object.assign({}, body || {}, {
              code: err.status ? Number(err.status) : null,
              message: err.message || 'Request failed',
              errno: err.code || null
            });
            reject(errorObj);
            return;
          }
          resolve(body);
        });
      };

      doRequest();
    });
}
